import { render, staticRenderFns } from "./OpenFileComponent.vue?vue&type=template&id=ff6517ce&lang=pug"
import script from "./OpenFileComponent.vue?vue&type=script&lang=ts"
export * from "./OpenFileComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff6517ce')) {
      api.createRecord('ff6517ce', component.options)
    } else {
      api.reload('ff6517ce', component.options)
    }
    module.hot.accept("./OpenFileComponent.vue?vue&type=template&id=ff6517ce&lang=pug", function () {
      api.rerender('ff6517ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/OpenFileComponent.vue"
export default component.exports